<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('user.editProfile') }}
                <small v-if="data.id !== null"> - {{ data.username }}</small>
            </heading>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <div class="form-group">
                        <label class="">{{ $t('company.fields.email') }}
                            <required-icon></required-icon>
                        </label>
                        <input type="text" v-model="data.email" class="form-control"/>
                        <small class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</small>
                    </div>
                    <div class="form-group">
                        <label class="">{{ $t('company.fields.username') }}
                            <required-icon></required-icon>
                        </label>
                        <input type="text" v-model="data.username" class="form-control"/>
                        <small class="text-danger" v-if="errors['username']">{{ errors['username'][0] }}</small>
                    </div>
                    <div class="form-group" v-if="data.id === null">
                        <label class="">{{ $t('company.fields.password') }}<required-icon></required-icon></label>
                        <input type="password" v-model="data.password" class="form-control"/>
                        <small class="text-danger" v-if="errors['password']">{{ errors['password'][0] }}</small>
                    </div>
                    <div class="form-group">
                        <label class="">{{ $t('company.fields.locale') }}
                            <required-icon></required-icon>
                        </label>
                        <select class="form-control" v-model="data.locale">
                            <option v-for="(name, key) in $t('core.languages')" :value="key" :selected="key === $root.language">{{ name }}</option>
                        </select>
                        <small class="text-danger" v-if="errors['locale']">{{ errors['locale'][0] }}</small>
                    </div>
                    <div class="form-group" v-if="$root.isAdmin">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="can_view_all_bookings" v-model="data.can_view_all_bookings">
                            <label class="custom-control-label" for="can_view_all_bookings">{{ $t('company.fields.canViewAllBookings') }}</label>
                        </div>
                        <small class="text-muted">{{ $t('company.fields.canViewAllBookingsContext') }}</small>

                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="can_view_all_pickups" v-model="data.can_view_all_pickups">
                                <label class="custom-control-label" for="can_view_all_pickups">{{ $t('company.fields.canViewAllPickups') }}</label>
                            </div>
                            <small class="text-muted">{{ $t('company.fields.canViewAllPickupsContext') }}</small>
                        </div>
                    </div>
                    <div class="form-group" v-if="hasAlternativeReturnAddress">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="use_alternative_return_address" v-model="data.use_alternative_return_address">
                            <label class="custom-control-label" for="use_alternative_return_address">{{ $t('company.fields.useAlternativeReturnAddress') }}</label>
                        </div>
                        <small class="text-muted">{{ alternativeAddress.address + ' ' + alternativeAddress.postal_code + ' ' +  alternativeAddress.city + ' ' +  alternativeAddress.country }}</small>
                    </div>

                    <button class="btn btn-primary float-right" @click="store">{{ $t('core.actions.save') }}</button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserEdit',
    data: function () {
        return {
            data: {
                id: null,
                username: null,
                email: null,
                password: null,
                locale: null,
                can_view_all_bookings: false,
                can_view_all_pickups: false,
                use_alternative_return_address: false,
            },
            hasAlternativeReturnAddress: lgt.hasAlternativeReturnAddress,
            alternativeAddress: lgt.alternativeAddress,
            errors: [],
        }
    },
    methods: {
        store () {
            if(this.data.id === null) {
                let url = '/company/' + lgt.companyId + '/user'
                axios.post(url, this.data).then((response) => {
                    window.location.href = "/customers?success";
                    this.errors = []
                }).catch((err) => {
                    this.errors = err.response.data.errors
                })
            }else{
                let url = '/user/' + this.data.id
                axios.post(url, this.data).then((response) => {
                    this.$saveSuccess()
                    this.errors = []
                }).catch((err) => {
                    this.errors = err.response.data.errors
                })
            }
        },
    },
    created () {
        if (Object.prototype.hasOwnProperty.call(lgt, 'user')) {
            this.data = {
                id: lgt.user.id,
                username: lgt.user.username,
                email: lgt.user.email,
                locale: lgt.user.locale,
                can_view_all_bookings: lgt.user.can_view_all_bookings,
                can_view_all_pickups: lgt.user.can_view_all_pickups,
                use_alternative_return_address: lgt.user.use_alternative_return_address
            }
        }
    },
}
</script>
